export const fmtInt = (n) => (n === null || n === undefined ? "—" : Math.round(n).toLocaleString("en-MY"));

export const fmtDec = (n, digits = 1) => (n === null || n === undefined ? "—" : Number(n).toLocaleString("en-MY", { minimumFractionDigits: digits, maximumFractionDigits: digits }));

export const fmtPct = (n, digits = 1) => (n === null || n === undefined ? "—" : `${Number(n).toFixed(digits)}%`);

export const fmtMYR = (n, digits = 0) =>
  n === null || n === undefined
    ? "—"
    : `RM ${Number(n).toLocaleString("en-MY", {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
      })}`;

/** Compact money for tiles: RM 2.8M / RM 471k */
export const fmtMYRShort = (n) => {
  if (n === null || n === undefined) return "—";
  const a = Math.abs(n);
  if (a >= 1_000_000) return `RM ${(n / 1_000_000).toFixed(2)}M`;
  if (a >= 10_000) return `RM ${Math.round(n / 1000)}k`;
  return fmtMYR(n);
};

/** Estimated USD for AI key usage: cents matter at this scale, so small amounts keep 4 decimals. */
export const fmtUSD = (n) => {
  if (n === null || n === undefined) return "—";
  const a = Math.abs(n);
  if (a === 0) return "$0.00";
  if (a < 1) return `$${Number(n).toFixed(4)}`;
  if (a < 1000) return `$${Number(n).toFixed(2)}`;
  return `$${Number(n).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;
};

/** Compact token counts: 1,234 / 23.8k / 1.2M */
export const fmtTokens = (n) => {
  if (n === null || n === undefined) return "—";
  const a = Math.abs(n);
  if (a >= 1_000_000) return `${(n / 1_000_000).toFixed(2)}M`;
  if (a >= 10_000) return `${(n / 1000).toFixed(1)}k`;
  return fmtInt(n);
};

export const fmtDelta = (d, kind = "pct", digits = 1) => {
  if (d === null || d === undefined) return null;
  const sign = d > 0 ? "+" : "";
  return kind === "pts" ? `${sign}${Number(d).toFixed(digits)} pts` : `${sign}${Number(d).toFixed(digits)}%`;
};

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const fmtDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso + "T00:00:00");
  return `${d.getDate()} ${MONTHS[d.getMonth()]}`;
};

export const fmtDateLong = (iso) => {
  if (!iso) return "";
  const d = new Date(iso + "T00:00:00");
  return d.toLocaleDateString("en-MY", { weekday: "short", day: "numeric", month: "short", year: "numeric" });
};

export const fmtRange = (start, end) => (start && end ? `${fmtDate(start)} – ${fmtDate(end)}` : "");

export const fmtTimeAgo = (iso) => {
  if (!iso) return "";
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 90) return "just now";
  if (diff < 3600) return `${Math.round(diff / 60)} min ago`;
  if (diff < 86400) return `${Math.round(diff / 3600)} h ago`;
  return `${Math.round(diff / 86400)} d ago`;
};

export const DAY_FULL = { Mon: "Monday", Tue: "Tuesday", Wed: "Wednesday", Thu: "Thursday", Fri: "Friday", Sat: "Saturday", Sun: "Sunday" };

export const dayTip = (row) => (row ? `${DAY_FULL[row.day] || row.day}${row.date ? ` · ${fmtDate(row.date)}` : ""}` : "");

/** Chart colours resolve from CSS variables so both themes render correctly. */
export const CHART = {
  gold: "hsl(var(--chart-1))",
  copper: "hsl(var(--chart-2))",
  teal: "hsl(var(--chart-3))",
  sky: "hsl(var(--chart-4))",
  gray: "hsl(var(--chart-5))",
  rose: "hsl(var(--chart-6))",
  violet: "hsl(var(--chart-7))",
  olive: "hsl(var(--chart-8))",
  grid: "hsl(var(--grid) / 0.12)",
  axis: "hsl(var(--grid) / 0.25)",
  weekend: "hsl(var(--gold) / 0.07)",
  prev: "hsl(var(--chart-5) / 0.9)",
  success: "hsl(var(--success))",
  danger: "hsl(var(--danger))",
  warning: "hsl(var(--warning))",
  holiday: { MY: "hsl(var(--holiday-my))", SG: "hsl(var(--holiday-sg))", JOHOR: "hsl(var(--holiday-johor))", school: "hsl(var(--holiday-school-band))", payday: "hsl(var(--holiday-payday))", custom: "hsl(var(--holiday-custom))", demand: "hsl(var(--holiday-demand))" },
};
export const SERIES = [CHART.gold, CHART.sky, CHART.teal, CHART.copper, CHART.rose, CHART.violet, CHART.olive, CHART.gray];

export const tickStyle = { fill: "hsl(var(--muted-foreground))", fontSize: 12, fontFamily: "IBM Plex Sans" };
